<template>
  <div
    class="v2-section"
    :class="[
      theme,
      { 'wave-top': waveTop },
      { 'wave-bottom': waveBottom },
      waveTop ? `wave-top-${theme}` : '',
      waveBottom ? `wave-bottom-${theme}` : '',
    ]"
  >
    <div class="container">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: "app-section",
});

defineProps({
  theme: {
    type: String,
    required: false,
    default: "dark",
    validator: (value: string) => {
      return [
        "light-lilac",
        "nude",
        "blue",
        "dark",
        "dark grid",
        "peach",
        "nude grid",
        "pink grid",
        "pink",
        "nude grid-dark",
        "peach grid",
      ].includes(value);
    },
  },
  waveTop: {
    type: Boolean,
    default: false,
  },
  waveBottom: {
    type: Boolean,
    default: false,
  },
});
</script>

<style lang="scss">
@import "./index.scss";
</style>
